import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import React, { useEffect, useState } from 'react';
import Switch from '@material-ui/core/Switch';
import useGlobalStyles from '../../styles/globalStyles';

interface IProfile {
    toggleProfilePicRequired: Function;
}
const Profile = ({ toggleProfilePicRequired }: IProfile) => {
    const [state, setState] = useState(false);
    useEffect(() => {}, []);
    const handleToggle = () => {
        toggleProfilePicRequired({ isProfilePicRequired: !state });
        setState(!state);
    };
    const globalClasses = useGlobalStyles();

    return (
        <React.Fragment>
            <Grid container spacing={3}>
                <Grid item xs={6}>
                    <Card>
                        <CardHeader classes={{ root: globalClasses.cardHeader }} title="Is profile pic required?" />
                        <CardContent>
                            <IconButton aria-label="Settings">
                                <Switch
                                    checked={state}
                                    name={'isProfilePicRequired'}
                                    onChange={handleToggle}
                                    title={'Is profile pic required?'}
                                    value={state}
                                />
                            </IconButton>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
        </React.Fragment>
    );
};
export default Profile;
